import React, { useContext, useEffect, useState } from "react";
import { Box, Container, Grid, Button, useMediaQuery } from "@mui/material";
// import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import {
  useEthTokenContract,
  useBscTokenContract,
  useEthBridgeContract,
  useBscBridgeContract,
  ToastNotify,
} from "../../ConnectivityAss/hooks";
import logo from "./assets/logo.ico";

import bsc from "./assets/bnb-token-icon.png";
import eth from "./assets/ethereum-icon.svg";
import { AppContext, gasEstimationForAll, url } from "../../utils";
import { formatUnits, parseUnits } from "@ethersproject/units";
import Loading from "../../loading";
import axios from "axios";

function RouterSwap({ setOpen, currentChainId }) {
  const matches = useMediaQuery("(max-width: 600px)");
  const mobile = useMediaQuery("(max-width:1050px)");
  const mobile2 = useMediaQuery("(max-width:400px)");
  const [amount, setamount] = useState();
  const { account, signer, web3Provider, connect } = useContext(AppContext);
  const [bscBalance, setbscBalance] = useState(0);
  const [ethBalance, setethBalance] = useState(0);
  const ethTokenContract = useEthTokenContract();
  const bscTokenContract = useBscTokenContract();
  const ethBridgeContract = useEthBridgeContract(signer);
  const bscBridgeContract = useBscBridgeContract(signer);
  const [loading, setloading] = useState(false);
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });

  const init = async () => {
    try {
      const bscdecimal = await bscTokenContract.decimals();
      const ethdecimal = await ethTokenContract.decimals();
      const bscbalance = await bscTokenContract.balanceOf(account);
      const ethbalance = await ethTokenContract.balanceOf(account);
      console.log(+bscbalance, +ethbalance, "balances");
      setbscBalance(+formatUnits(bscbalance, bscdecimal));
      setethBalance(+formatUnits(ethbalance, ethdecimal));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(async () => {
    if (account) {
      init();
    }
  }, [account]);

  const swapHandler = async () => {
    setAlertState({
      open: true,
      message: `Comming Soon!`,
      severity: "success",
    });
    // if (!account) {
    //   setAlertState({
    //     open: true,
    //     message: `Please connect to wallet`,
    //     severity: "success",
    //   });
    // } else if (!amount) {
    //   setAlertState({
    //     open: true,
    //     message: `Please enter amount`,
    //     severity: "success",
    //   });
    // } else if (isNaN(amount) || +amount <= 0) {
    //   setAlertState({
    //     open: true,
    //     message: `Please enter valid amount`,
    //     severity: "success",
    //   });
    // } else {
    //   try {
    //     setloading(true);
    //     const bscdecimal = await bscTokenContract.decimals();
    //     const ethdecimal = await ethTokenContract.decimals();
    //     console.log(currentChainId, "currentChainId");
    //     if (currentChainId === 3) {
    //       let data = [account, parseUnits(amount, ethdecimal)];
    //       let fn = ethBridgeContract.estimateGas.burn;
    //       const tx = await ethBridgeContract.burn(...data, {
    //         gasLimit: gasEstimationForAll(account, fn, data),
    //       });
    //       let serverData = {
    //         to: account,
    //         amount: parseUnits(amount, ethdecimal),
    //         transaction: tx,
    //       };
    //       axios.post(url + "/send-transaction-eth", serverData);
    //       await tx.wait();
    //       setAlertState({
    //         open: true,
    //         message: `Success`,
    //         severity: "success",
    //       });
    //     } else if (currentChainId === 97) {
    //       let data = [account, parseUnits(amount, bscdecimal)];
    //       let fn = bscBridgeContract.estimateGas.burn;
    //       const tx = await bscBridgeContract.burn(...data, {
    //         gasLimit: gasEstimationForAll(account, fn, data),
    //       });
    //       let serverData = {
    //         to: account,
    //         amount: parseUnits(amount, bscdecimal),
    //         transaction: tx,
    //       };
    //       axios.post(url + "/send-transaction-bsc", serverData);
    //       await tx.wait();
    //       setAlertState({
    //         open: true,
    //         message: `Success`,
    //         severity: "success",
    //       });
    //     } else {
    //       setAlertState({
    //         open: true,
    //         message: `You are connected to wrong network`,
    //         severity: "success",
    //       });
    //     }
    //     init();
    //     setloading(false);
    //   } catch (error) {
    //     if (error?.data?.message) {
    //       setAlertState({
    //         open: true,
    //         message: error?.data?.message,
    //         severity: "error",
    //       });
    //     } else {
    //       setAlertState({
    //         open: true,
    //         message: error?.message,
    //         severity: "error",
    //       });
    //     }
    //     setloading(false);
    //   }
    // }
  };
  const testHandler = async () => {
    setAlertState({
      open: true,
      message: `Comming Soon!`,
      severity: "success",
    });
    // try {
    //   setloading(true);
    //   console.log(web3Provider);
    //   await axios.post(url + "/bsctest", {});
    //   setAlertState({
    //     open: true,
    //     message: `Success`,
    //     severity: "success",
    //   });

    //   setloading(false);
    // } catch (error) {
    //   if (error?.data?.message) {
    //     setAlertState({
    //       open: true,
    //       message: error?.data?.message,
    //       severity: "error",
    //     });
    //   } else {
    //     setAlertState({
    //       open: true,
    //       message: error?.message,
    //       severity: "error",
    //     });
    //   }
    //   setloading(false);
    // }
  };

  return (
    <Box py={8}>
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />
      <Container maxWidth="md">
        <Box
          className="border"
          width="100%"
          px={mobile ? "18px" : "70px"}
          py={mobile ? "20px" : "48px"}
          sx={{
            background: " rgba(248, 248, 248, 0.1)",
            backdropFilter: "blur(10px)",
            borderRadius: "20px",
            zIndex: "100",
            maxWidth: "800px",
            margin: "auto",
            textAlign: "center",
          }}
        >
          <Box
            borderRadius="20px"
            bgcolor="rgba(255, 255, 255, 0.144)"
            p={{ xs: 2, sm: 5 }}
          >
            <Box display="flex" justifyContent="space-between" mb={3}>
              <Box fontSize="14px" color="#fff">
                From
              </Box>

              <Box fontSize="14px" color="#fff">
                Balance:{" "}
                {currentChainId === 3
                  ? ethBalance.toFixed(4)
                  : bscBalance.toFixed(4)}
              </Box>
            </Box>

            <Grid
              container
              spacing={4}
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Grid item xs={12} sm={11} md={5}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  borderBottom="1px solid #fff"
                >
                  <input
                    value={amount}
                    onChange={(e) => setamount(e.target.value)}
                    type="number"
                    pattern="^[0-9]*[.,]?[0-9]*$"
                    placeholder={"0.0"}
                    spellCheck="false"
                    style={{
                      backgroundColor: "transparent",
                      outline: "none",
                      border: "none",
                      fontSize: "28px",
                      fontWight: 600,
                      width: "100%",
                      color: "#FFF",
                      flexBasis: "100%",
                      paddingBottom: "5px",
                    }}
                  />

                  <Button
                    onClick={() => {
                      if (currentChainId === 3) {
                        setamount(ethBalance.toFixed(4));
                      } else if (currentChainId === 97) {
                        setamount(bscBalance.toFixed(4));
                      }
                    }}
                    variant="outlined"
                    style={{
                      fontSize: "14px",
                      color: "#fff",
                      border: "1px solid #fff",
                      padding: matches ? "3px 5px" : "5px 7px",
                      minWidth: "40px",
                      marginBottom: "3px",
                    }}
                  >
                    MAX
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={12} sm={11} md={7}>
                <Box display="flex" justifyContent={"center"}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #fff",
                      padding: "13px 20px",
                      borderRadius: "14px",
                      "&:focus": {
                        borderColor: "silver",
                        boxShadow:
                          " 0px 0px 23px 2px rgba(255, 255, 255, 0.144)",
                      },
                    }}
                    // onClick={() => setOpen(true)}
                  >
                    {/* {currentChainId === 97 || currentChainId === 3 ? ( */}
                    <>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width={{ xs: "30px", sm: "40px" }}
                        height={{ xs: "30px", sm: "40px" }}
                        bgcolor="#fff"
                        borderRadius="50%"
                        mr={1}
                      >
                        <img
                          width={matches ? "20px" : "25px"}
                          src={logo}
                          // src={currentChainId === 3 ? eth : bsc}
                          alt=""
                        />
                      </Box>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                      >
                        <Box
                          color="#fff"
                          fontSize={{ xs: "0.8rem", sm: "1rem" }}
                          fontWeight={600}
                        >
                          <Box component="span" fontWeight={400}>
                            $
                          </Box>
                          XCON
                          {/* {currentChainId === 3 ? "Eth" : "BSC"} */}
                        </Box>
                        {/* <Box
                          color="#fff"
                          lineHeight="1px"
                          fontSize={{ xs: "12px", sm: "14px" }}
                          fontWeight={400}
                          style={{ textTransform: "lowercase" }}
                        >
                          Testnet
                        </Box> */}
                      </Box>

                      {/* <Box
                        bgcolor="rgba(255, 255, 255, 0.144)"
                        ml={4}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width={{ xs: "25px", sm: "30px" }}
                        height={{ xs: "25px", sm: "30px" }}
                        borderRadius="50%"
                      >
                        <ArrowDropDownOutlinedIcon
                          style={{
                            color: "#fff",
                          }}
                        />
                      </Box> */}
                    </>
                    {/* ) : (
                      <Box color="red" fontSize="20px">
                        ! Wrong network
                      </Box>
                    )} */}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          {/* <Box
            textAlign="left"
            color="#fff"
            fontSize={{ xs: "12px", sm: "14px" }}
            mt={0.5}
          >
            Transaction Fee: 00{" "}
          </Box> */}
          <Grid item container xs={12} style={{ margin: "30px 0px" }}>
            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                marginLeft: "20px",
              }}
            >
              <Box
                bgcolor="rgba(20, 23, 42, 0.3)"
                width="40px"
                height="40px"
                borderRadius="50%"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <ArrowDownwardIcon
                  sx={{
                    color: "#fff",
                    "&:hover": {
                      cursor: "pointer",
                    },
                  }}
                />
              </Box>
            </Grid>
          </Grid>
          <Box
            borderRadius="20px"
            bgcolor="rgba(255, 255, 255, 0.144)"
            p={{ xs: 2, sm: 5 }}
          >
            <Box display="flex" justifyContent="space-between" mb={3}>
              <Box fontSize="14px" color="#fff">
                To
              </Box>
              <Box fontSize="14px" color="#fff">
                Balance:{" "}
                {currentChainId !== 3
                  ? ethBalance.toFixed(4)
                  : bscBalance.toFixed(4)}
              </Box>
            </Box>

            <Grid
              container
              spacing={4}
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <Grid item xs={12} sm={11} md={5}>
                <Box>
                  <input
                    value={amount}
                    // universal input options
                    readOnly
                    inputMode="decimal"
                    title="Token Amount"
                    autoComplete="off"
                    autoCorrect="off"
                    // text-specific options
                    type="text"
                    pattern="^[0-9]*[.,]?[0-9]*$"
                    placeholder={"0.0"}
                    minLength={1}
                    maxLength={79}
                    spellCheck="false"
                    style={{
                      backgroundColor: "transparent",
                      outline: "none",
                      border: "none",
                      fontSize: "28px",
                      fontWight: 600,
                      width: "100%",
                      color: "#FFF",
                      flexBasis: 2,
                      paddingBottom: "5px",
                      borderBottom: "1px solid #fff",
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={11} md={7}>
                <Box display="flex" justifyContent={"center"}>
                  <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid #fff",
                      padding: "13px 20px",
                      borderRadius: "14px",
                      "&:focus": {
                        borderColor: "silver",
                        boxShadow:
                          " 0px 0px 23px 2px rgba(255, 255, 255, 0.144)",
                      },
                    }}
                    // onClick={() => setOpen(true)}
                  >
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width={{ xs: "30px", sm: "40px" }}
                      height={{ xs: "30px", sm: "40px" }}
                      bgcolor="#fff"
                      borderRadius="50%"
                      mr={1}
                    >
                      <img
                        width={matches ? "20px" : "25px"}
                        src={logo}
                        // src={currentChainId === 3 ? bsc : eth}
                        alt=""
                      />
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      // mb={1}
                    >
                      <Box
                        fontSize={{ xs: "0.8rem", sm: "1rem" }}
                        fontWeight={600}
                        color="#fff"
                      >
                        <Box component="span" fontWeight={400}>
                          $
                        </Box>
                        CON
                        {/* {currentChainId === 3 ? "BSC" : "Eth"} */}
                      </Box>
                      {/* <Box
                        color="#fff"
                        lineHeight="1px"
                        fontSize={{ xs: "12px", sm: "14px" }}
                        fontWeight={400}
                        style={{ textTransform: "lowercase" }}
                      >
                        Testnet
                      </Box> */}
                    </Box>

                    {/* <Box
                      bgcolor="rgba(255, 255, 255, 0.144)"
                      ml={currentChainId === 1 ? 4 : 2}
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width={{ xs: "25px", sm: "30px" }}
                      height={{ xs: "25px", sm: "30px" }}
                      borderRadius="50%"
                    >
                      <ArrowDropDownOutlinedIcon style={{ color: "#fff" }} />
                    </Box> */}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Action Button */}
          <Box my={5} display="flex" justifyContent="center">
            {account ? (
              <>
                {" "}
                <Button
                  sx={{
                    fontSize: mobile ? "15px" : "25px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    paddingX: "40px",
                    fontFamily: "light",
                    marginRight: "20px",
                  }}
                  onClick={testHandler}
                >
                  TEST
                </Button>
                <Button
                  sx={{
                    fontSize: mobile ? "15px" : "25px",
                    background: "#FAA631",
                    "&:hover": {
                      background: "white",
                      color: "#FAA631",
                    },
                    color: "white",
                    borderRadius: "10px",
                    fontFamily: "light",
                    paddingX: "40px",
                  }}
                  onClick={swapHandler}
                >
                  SWAP
                </Button>
              </>
            ) : (
              <Button
                sx={{
                  fontSize: mobile ? "15px" : "25px",
                  background: "#FAA631",
                  "&:hover": {
                    background: "white",
                    color: "#FAA631",
                  },
                  color: "white",
                  borderRadius: "10px",
                  fontFamily: "light",
                  paddingX: "40px",
                }}
                onClick={connect}
              >
                CONNECT WALLET
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default RouterSwap;
